import Icon from '@mui/material/Icon'
import React from 'react'

import { UIconProps } from './type'

export const UIcon = ({ color = 'primary', name, ...props }: UIconProps) => {
  return (
    <Icon color={color} {...props}>
      {name}
    </Icon>
  )
}
